import React, { useState } from "react";
import { connect } from "react-redux";
import { object, func, bool, string } from "prop-types";

import {
  onboardUpdateState,
  updateUserInProfileSilent,
  updateGeneralConsent,
} from "../redux/actions";

import PersonalDeclarationView from "../components/PersonalDeclaration/index";

import history from "../history";
import { trackOnboardingStep } from "../helpers/productMetrics";

const onboardNextRoute = "/onboard/done";
const editProfileNextRoute = "/profile";

const usePersonalDeclarationState = (appData) => {
  const initialState = {
    generalConsent: appData.generalConsent,
  };

  const [state, setState] = useState(initialState);

  const handlers = {
    onChange: (key, val) => setState({ ...state, [key]: val }),
  };

  return [state, handlers];
};

const PersonalDeclaration = (props) => {
  const {
    appData,
    onboardState,
    description,
    updateProfile,
    updateConsent,
    updateOnboardState,
    onBoarding = true,
  } = props;

  const [state, handlers] = usePersonalDeclarationState(appData);

  const handleSubmit = () => {
    const cookieconsent = window.initCookieConsent();
    const { candidateRef, emailAddress } = appData;
    const { generalConsent } = state;

    const updatedUserData = {
      candidateRef,
      emailAddress,
    };

    const getGeneralConsent = async () => {
      if (generalConsent) {
        return updateConsent();
      }

      return Promise.resolve();
    };

    Promise.all([
      updateProfile(candidateRef, updatedUserData),
      getGeneralConsent(),
      updateOnboardState({ ...onboardState, personalDeclaration: true }),
      onBoarding && trackOnboardingStep("Personal Declaration"),
      history.push(onBoarding ? onboardNextRoute : editProfileNextRoute),
    ]);
  };

  const handleLink = () => {
    const { candidateRef, emailAddress } = appData;

    handlers.onChange("handleUserConsent", false);

    const updatedUserData = {
      candidateRef,
      emailAddress,
      generalConsent: false,
    };

    Promise.all([
      updateProfile(candidateRef, updatedUserData),
      updateOnboardState({ ...onboardState, personalDeclaration: true }),
      history.push(onBoarding ? onboardNextRoute : editProfileNextRoute),
    ]);
  };

  return (
    <PersonalDeclarationView
      {...props}
      {...state}
      {...handlers}
      description={description}
      handleSubmit={handleSubmit}
      handleLink={handleLink}
      onBoarding={onBoarding}
      onboardNextRoute={onboardNextRoute}
    />
  );
};

PersonalDeclaration.propTypes = {
  appData: object.isRequired,
  updateProfile: func.isRequired,
  updateOnboardState: func.isRequired,
  onboardState: object.isRequired,
  onBoarding: bool,
  description: string.isRequired,
  loading: bool.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  onboardState: state.core.onboardState,
  description: state.core.umbracoContent.personalDeclarationSub,
  loading: state.core.loading,
});

const mapDispatchToProps = {
  updateOnboardState: onboardUpdateState,
  updateProfile: updateUserInProfileSilent,
  updateConsent: updateGeneralConsent,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(PersonalDeclaration);
